export default __webpack_public_path__ + "static/media/home-yoga-meditation-sound-therapy-bg.6157ee77.jpg";